import { Outlet } from 'react-router-dom';

function Post() {
    return <Outlet />;
}

export default Post;
